<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>시험 신청</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>외식 경영 관리사 시험 신청 </span>
          </h1>
        </div>
        <div class="page_con" v-if="!$Util.isEmpty(items)">
          <div class="table hover">
            <!--'게시판: hover'-->
            <div class="row head">
              <div class="cell fix150"><p>번호</p></div>
              <div class="cell"><p>제목</p></div>
              <div class="cell fix240"><p>등록일</p></div>
            </div>
            <div class="row" v-for="(item, index) in items" :key="index">
              <div class="cell fix150">
                <p>{{ pageInfo.virtualNum - index }}</p>
              </div>
              <div class="cell">
                <p class="left">
                  <!--아래 영역 클릭하면 이동하도록 해주세요-->
                  <span class="board_ttl" @click="fnView(item)">{{
                    item.titleName
                  }}</span>
                </p>
              </div>
              <div class="cell fix240">
                <p class="date">
                  {{ $moment(item.regDate).format('YYYY.MM.DD') }}
                </p>
              </div>
            </div>
          </div>
          <pagination
            v-bind="pageInfo"
            v-model="pageInfo.page"
            @change="fetchData"
          />
        </div>
        <div class="page_con" v-else>
          <div class="empty_wrap">
            <div class="empty">
              <span>시험 신청 기간이 아닙니다.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-exam-apply-index',
  data: function() {
    return {
      params: {
        page: 1,
        limit: 10
      },
      pageInfo: {},
      items: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function(page = 1) {
      this.params.page = page
      const res = await this.$ManagerSvc.getListBoxExam(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    fnView: function(item) {
      this.$router.push({
        path: '/manager/exam/apply/view',
        query: { examinationNo: item.examinationNo }
      })
    }
  }
}
</script>

<style scoped></style>
